export type SortButtonModeTypes =
  | 'toggle-default'
  | 'toggle-no-default'
  | 'active-inactive';
export enum SortButtonMode {
  TOGGLE_DEFAULT = 'toggle-default',
  TOGGLE_NO_DEFAULT = 'toggle-no-default',
  ACTIVE_INACTIVE = 'active-inactive',
}
